import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorBybitMall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M9.25 15a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 .75.75v5.5h-1.5v-4.75h-2.5v4.75h-1.5V15Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M5.387 2.25a1.15 1.15 0 0 0-1.03.639L1.828 7.984a.752.752 0 0 0-.04.572l.001.002.001.003.003.009.01.03.038.1a7.07 7.07 0 0 0 .698 1.362c.35.527.915 1.195 1.71 1.5V19.5a2.25 2.25 0 0 0 2.25 2.25h11a2.25 2.25 0 0 0 2.25-2.25v-8.037c.72-.357 1.27-.98 1.632-1.475a8.294 8.294 0 0 0 .788-1.33l.012-.026.003-.008.001-.003.001-.001a.75.75 0 0 0 .01-.58l-2.01-5.064a1.15 1.15 0 0 0-1.069-.726H5.387ZM21.5 8.317l.686.303-.686-.303Zm-3.25 3.412V19.5a.75.75 0 0 1-.75.75h-11a.75.75 0 0 1-.75-.75v-7.846c.39-.09.757-.256 1.081-.445a7.437 7.437 0 0 0 1.325-1.017c.223-.21.425-.42.599-.61.127.176.274.365.438.554.588.683 1.575 1.59 2.807 1.59s2.219-.907 2.807-1.59c.145-.168.276-.335.393-.493.166.205.36.428.575.648.374.382.837.781 1.362 1.064.332.18.708.322 1.113.374ZM2.5 8.317l-.711.24s0-.002.71-.24Zm.852.111a5.858 5.858 0 0 1-.033-.074L5.604 3.75h13.275l1.8 4.534-.028.054a6.777 6.777 0 0 1-.48.765c-.442.603-.95 1.05-1.436 1.134-.25.042-.543-.017-.886-.202-.343-.185-.686-.47-1.002-.793a8.374 8.374 0 0 1-1.026-1.293l-.013-.02-.002-.003a.75.75 0 0 0-1.301.038l-.002.003-.009.016-.04.072a7.506 7.506 0 0 1-.783 1.102c-.558.647-1.154 1.07-1.671 1.07-.517 0-1.114-.423-1.671-1.07a7.519 7.519 0 0 1-.824-1.174l-.009-.016-.001-.003a.75.75 0 0 0-1.267-.09l-.003.004-.013.018a9.588 9.588 0 0 1-.284.354c-.197.234-.475.544-.8.851-.329.31-.69.6-1.051.811-.368.214-.685.314-.938.314-.473 0-.937-.371-1.35-.994a5.57 5.57 0 0 1-.437-.804Z"
    />
  </svg>
);
export default SvgTwoColorBybitMall;
